import { queryOptions } from '@tanstack/react-query';
import { checkVersion, type VersionCheckResult } from './version-check';
import { fetchVersionManifest } from './version-manifest.fetch';

/** 버전 체크 query key — 앱 전역 단일. observer/invalidate 가 공유하는 SSOT. */
export const VERSION_CHECK_QUERY_KEY = ['version-check'] as const;

/**
 * 버전 체크 query 정의 SSOT. `fetchVersionManifest`(배포 매니페스트 조회) → `checkVersion`(현재 실행
 * 컨텍스트 판정)을 합친 결과(`VersionCheckResult`)를 캐시한다.
 *
 * 전역 `refetchOnWindowFocus: true`(shared/api/query/client.ts)를 그대로 타 **화면 포커스마다 재검사** —
 * 배포 직후 앱을 다시 포커스하면 강제/넛지 업데이트가 뒤늦게라도 잡힌다. staleTime 은 default(5s) — 짧은
 * 포커스 왕복에서 매니페스트 조회를 도배하지 않도록.
 *
 * 실패는 react-query 의 error 로만 표면화(throw 아님) — 호출측이 fail-open 으로 무시한다(버전 확인
 * 실패가 앱 사용을 막아선 안 된다).
 */
export const versionCheckQueryOptions = () =>
  queryOptions<VersionCheckResult>({
    queryKey: VERSION_CHECK_QUERY_KEY,
    queryFn: () => fetchVersionManifest().then(checkVersion),
  });
